import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableBody';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import '../../../assets/style/style.css';
import { useParams, useNavigate } from 'react-router-dom';
import Card from "@mui/material/Card";
import { useTranslation } from "react-i18next";

function ReturnItem(props) {
  const navigate   = useNavigate();
  const { t }      = useTranslation();
  const returnID   = props.returnID;
  const returnItem = props.returnItem;

  let returnItemColumns = returnItem.returnItemColumns;
  let returnRowsList    = returnItem.returnRowsList;

  return (
        <Grid item key="return-item" xs={12}>
          <Typography color="text.secondary" sx={{ fontSize: '20px' }} pt={1} gutterBottom>
            {t('returnRequestedProduct')}
          </Typography>

          <Card variant="outlined">
            <Grid item xs={12}>
                <TableContainer>
                  <Table>
                    <TableHead key={1}>
                      <TableRow key={1}>
                        {returnItemColumns.map((column, index) => (
                          <TableCell key={"key-" + index}>{column.label}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody key={2}>
                      {returnRowsList.map((row, index) => (
                        <TableRow key={index}>
                          {returnItemColumns.map((column) => (
                            <TableCell key={column.field + '-' + index}>
                              {row[column.field]}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
            </Grid>
          </Card>
        </Grid>
   );
}
export default ReturnItem;
